export class ConfigValidationError extends Error {
  name = 'ConfigValidationError';

  constructor(readonly promoId: string, readonly problems: string[]) {
    super(
      `[remoteConfig] invalid config for promoId ${promoId}: ${problems.join(
        '; '
      )}`
    );
  }
}
